// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UuoLm","label":"SetPasswdForm_label__I-KBp"};